<div class="wrapper">
    <div class="dashboard-row">
        <div class="title-wrapper">
            <p class="font-weight-bold">
                Datei Upload
            </p>
        </div>
    </div>
    <div class="dashboard-row">
        <app-file-selector
                title="Produkte"
                postPath="/api/products"
                fileName="Produkte.xlsx"
                [allowReplace]="true"
        >
        </app-file-selector>
        <app-file-selector
                title="Brillanten"
                postPath="/api/brillants"
                fileName="Brillianten.xlsx"
                [allowReplace]="true"
        >
        </app-file-selector>
        <app-file-selector
                title="Werte"
                postPath="/api/values"
                fileName="Werte.xlsx"
        >
        </app-file-selector>
    </div>
</div>
